
import { onMounted, ref, onBeforeUnmount } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "ScrollToTopButton",
  components: { FontAwesomeIcon },
  setup() {
    const scrollToTopButton = ref();
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const userScroll = () => {
      window.scrollY > 0
        ? scrollToTopButton.value.classList.add("show-button")
        : scrollToTopButton.value.classList.remove("show-button");
    };

    onMounted(() => {
      window.addEventListener("scroll", userScroll);
      if (window.scrollY > 0)
        scrollToTopButton.value.classList.add("show-button");
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", userScroll);
    });
    return { scrollToTopButton, scrollToTop };
  },
};
